import { render } from "./Home.vue?vue&type=template&id=1a6ec6aa"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render

export default script